export default {
  name: "HeroSection",

  data() {
    return {
      hero_data: {
        badge_text: "SANAS Accredited Verification Ready",

        headline_prefix: "Master Your",
        headline_highlight: "B-BBEE",
        headline_suffix: "Compliance Journey",

        description:
          "GovFlow streamlines your BBBEE programme management, providing real-time visibility, automated alerts, and audit-ready verification packs for SANAS compliance.",

        primary_cta: {
          text: "Get Started →",
          route: "/login",
        },

        secondary_cta: {
          text: "Book a Demo",
          href: "#",
        },

        trust_indicators: [
          {
            key: "security",
            label: "Enterprise Security",
            icon: "bi bi-shield-check",
          },
          {
            key: "tracking",
            label: "Real-time Tracking",
            icon: "bi bi-graph-up",
          },
          {
            key: "audit",
            label: "Audit Ready",
            icon: "bi bi-clipboard-check",
          },
        ],

        compliance: {
          title: "Compliance Score",
          level: "Level 2",
          score: "84.7",
          score_label: "points",

          documents: {
            icon: "bi bi-file-earmark-check",
            count: "47 Documents",
            label: "Verified",
          },

          breakdown: [
            {
              key: "ownership",
              value: "25",
              label: "/27 Ownership",
            },
            {
              key: "skills",
              value: "18",
              label: "/25 Skills",
            },
            {
              key: "esd",
              value: "38",
              label: "/44 ESD",
            },
          ],

          trend: {
            icon: "bi bi-arrow-up-right-circle",
            value: "+12.4%",
            label: "This Quarter",
          },
        },
      },
    };
  },
};
